import { useTranslation } from '@frontend/i18n';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { useContentComposer } from '../../content-composer/content-composer-provider';
import { ToolboxButton } from '../../content-composer/toolbox-atoms/toolbox-button';
import { ButtonSection } from './button-section';

export const ButtonTool = () => {
  const { t } = useTranslation('content-composer');
  const { insertSection } = useContentComposer();

  return (
    <ToolboxButton
      icon='updates'
      title={t('Button')}
      subtitle={t('Insert a call to action button.')}
      onClick={() => insertSection(<ButtonSection />)}
      trackingId={`${BulkEmailPrefixes.Composer}-button-tool-btn`}
    >
      <ButtonSection />
    </ToolboxButton>
  );
};
